/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-01T16:33:48.765
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentFacility,
	getRentFacilityCreateInit,
	getRentFacilityEditInit,
	getRentFacilityView,
	deleteRentFacility
} from '@api/rentmanage/RentFacility';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentFacilityCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentFacilityCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentFacilityEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentFacilityEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentFacility({}, RentFacility) {
			return new Promise((resolve, reject) => {
				saveRentFacility(RentFacility)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentFacilityView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentFacilityView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentFacility({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentFacility({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
